<template>
  <v-card flat class="request-detail mt-5" max-width="600" style="margin: auto;">
    <v-alert v-if="error" border="top" colored-border type="error" elevation="2" class="ma-5">
      エラー：指定の申し込みを表示できません。
    </v-alert>
    <v-card v-if="item">
      <v-card-title>お申込み内容</v-card-title>
      <v-card-text>
        <p>お申込み日時：{{ item.requested_at }}</p>

        <v-subheader class="mt-5">ご提供データ</v-subheader>
        <v-card outlined>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="(item, idx) in item.file_items" :key="idx">
                  <td>{{ item.name }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>

        <p class="mt-5 black--text">現在の状態：{{ userState(item.state) }}</p>

        <div v-if="item.state !== '受注'">
          <div class="d-flex">
            <div style="width: 80px;">件数</div>
            <div style="width: 80px;">料金</div>
            <div style="width: 80px;">消費税</div>
          </div>
          <div v-for="(detailItem, idx) in item.detailItems" :key="idx" class="d-flex">
            <div style="width: 80px;">
              {{ detailItem.name }} {{ detailItem.count_number.toLocaleString() }}件
            </div>
            <div class="text-right pr-5" style="width: 80px;">
              {{ detailItem.price.toLocaleString() }}円
            </div>
            <div class="text-right pr-5" style="width: 80px;">
              {{ detailItem.tax.toLocaleString() }}円
            </div>
          </div>

          <div class="black--text mt-3 pr-5 text-right" style="width: 240px;">
            お支払い合計金額：{{ calcTotal() }}円
          </div>
        </div>

        <template v-if="showPayment">
          <p class="mt-5 black--text">お支払い：{{ item.is_paid ? '入金済' : '未入金' }}</p>
          <template v-if="item.is_paid === 0 && item.detailItems.length !== 0">
            <v-card
              v-if="item.payment_method === 'クレジット決済'"
              color="blue lighten-5"
              class="pa-5"
            >
              <div v-if="readyStripe">
                <form method="post" id="payment-form">
                  <div class="form-row mb-3">
                    <label for="card-element" class="green--text text--darken-3">
                      カード番号
                    </label>
                    <div id="card-element"></div>

                    <div id="card-errors" role="alert"></div>
                  </div>

                  <v-row>
                    <v-spacer />
                    <v-btn dark color="success" :disabled="paid" @click="pay">
                      <v-icon left>mdi-currency-jpy</v-icon>
                      支払う
                    </v-btn>
                  </v-row>
                </form>
                <v-divider class="mt-5" />
                <v-container class="mt-5">
                  <v-row>
                    <v-subheader>CVCについて</v-subheader>
                    <v-img src="crdit_card_cvc.png" />
                  </v-row>
                </v-container>
              </div>
              <div v-else>
                <v-btn dark color="success" @click="setUpStripe">
                  クレジットカードで支払う
                </v-btn>
              </div>
            </v-card>

            <v-dialog v-model="paymentCompleteDialog" max-width="400">
              <v-card>
                <v-card-title>
                  決済完了
                </v-card-title>
                <v-card-text>
                  <p>決済が完了しました。</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn text color="grey darken-2" @click="closePaymentComplete">
                    閉じる
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-card v-if="item.payment_method === '銀行振込'" class="pa-5 bank-info">
              <p><span style="color: #B71C1C;">作成完了メールをお受け取り後、20日以内</span>に以下のいずれかへお振込みください。</p>
              <table>
                <tbody>
                  <tr>
                    <th>振込先金融機関</th>
                    <td>りそな銀行 北浜支店</td>
                  </tr>
                  <tr>
                    <th>振込先口座番号</th>
                    <td>当座 1631650</td>
                  </tr>
                  <tr>
                    <th>振込先</th>
                    <td>株式会社メディブレーン</td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <th>振込先金融機関</th>
                    <td>三井住友銀行 大阪中央支店</td>
                  </tr>
                  <tr>
                    <th>振込先口座番号</th>
                    <td>当座 2009647</td>
                  </tr>
                  <tr>
                    <th>振込先</th>
                    <td>株式会社メディブレーン</td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <th>振込先金融機関</th>
                    <td>楽天銀行 ロック支店</td>
                  </tr>
                  <tr>
                    <th>振込先口座番号</th>
                    <td>普通 7004680</td>
                  </tr>
                  <tr>
                    <th>振込先</th>
                    <td>株式会社メディブレーン</td>
                  </tr>
                </tbody>
              </table>
              <p class="mt-3">※振込手数料はお客様にてご負担願います。</p>
            </v-card>
          </template>
        </template>

        <template v-if="item.state === '件数確認済'">
          <div class="d-flex justify-center">
            <v-btn
              color="primary"
              class="mt-5"
              @click="updateStateToFormalRequest"
            >
              料金に了承の上、発注する
            </v-btn>
          </div>
          <v-dialog v-model="updateStateCompleteDialog" max-width="400">
            <v-card>
              <v-card-title>
                正式発注完了
              </v-card-title>
              <v-card-text>
                <p>正式に発注を承りました。</p>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text color="grey darken-2" @click="closeUpdateStateComplete">
                  閉じる
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <template v-if="item.state === '完了' && item.result_items.length">
          <v-subheader class="mt-5">納品データ</v-subheader>
          <v-card outlined>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, idx) in item.result_items" :key="idx">
                    <td>{{ item.name }}</td>
                    <td style="width: 4em;">
                      <v-icon @click="download(item)">mdi-download</v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </template>

      </v-card-text>
    </v-card>
    <v-row justify="center" class="ma-5">
      <v-btn outlined color="grey" @click="$router.push('/request')">戻る</v-btn>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'Request',

  data: () => ({
    paid: false,
    item: null,
    requestItem: {},
    error: false,
    showCredit: false,
    showBankTransfer: false,
    paymentCompleteDialog: false,
    stripe: window.Stripe(
      'pk_live_51HOcIzLLa5oKcMTkafUrsCTzLnDq3t2AbDx42MAXH7TG1aqvwDa'
      + 'LLkpTPvl574rGKhG3UeUeblJiFikWjcD9RTrS00tRqwkA8H'
    ),
    /*
    stripe: window.Stripe(
      'pk_test_51HOcIzLLa5oKcMTkbcRoYpOk4874LCKA6gqjfvm45PjPS'
      + '6L7oFQ4U6PhutmWa4C93Mjs8seMUgbBMx2vmmJFDzxY00Eepfk7r9'
    ),
    */
    card: null,
    updateStateCompleteDialog: false,
    readyStripe: false
  }),
  computed: {
    showPayment() {
      if (this.item) {
        if (this.item.state === '受注') {
          return false;
        }
        if (this.item.state === '件数確認済') {
          return false;
        }
        return true;
      }
      return false;
    },
    showFormalRequest() {
      return false;
    }
  },
  mounted() {
    if (this.$store.state.loggedIn === false) {
      this.$store.commit('setAfterLoginPath', `/request/${this.$route.params.id}`);
      this.$router.push('/');
    } else {
      this.$store.dispatch('getRequestItems')
        .then(() => {
          this.item = this.$store.state.requestItems.find((requestItem) => {
            return requestItem.id === Number(this.$route.params.id);
          });
          if (!this.item) {
            this.error = true;
          }
          if (this.item.payment_method === 'クレジット決済') {
            if (this.item.is_paid === 0) {
              if (this.item.state === '正式発注') {
                this.$nextTick(() => {
                  this.createStripe();
                });
              }
            }
          }
        });
    }
  },
  /*
  updated() {
    if (this.item) {
      if (this.item.payment_method === 'クレジット決済') {
        if (this.item.is_paid === 0) {
          if (this.item.state === '正式発注') {
            this.$nextTick(() => {
              this.createStripe();
            });
          }
        }
      }
    }
  },
  */
  methods: {
    setUpStripe() {
      this.$store.dispatch('setUpStripe', this.item.id)
        .then(() => {
          if (this.$store.state.requestItem.client_secret) {
            this.requestItem = this.$store.state.requestItem;
            this.readyStripe = true;
            this.$nextTick(() => {
              this.createStripe();
            });
          } else {
            alert('決済準備エラー');
          }
        })
        .catch(() => {
          alert('決済の準備ができませんでした。');
        });
    },
    userState(state) {
      if (state === '完了') {
        return '完了しました。';
      }
      if (state === '作成中') {
        return 'レセプト作成中です。';
      }
      if (state === '正式発注') {
        return '正式発注を承りました。';
      }
      if (state === '件数確認済') {
        return '件数、料金をご確認ください。';
      }
      return 'お申し込みを受け付けました。';
    },
    download(item) {
      window.open(`/files/api/download.php?id=${this.$route.params.id}&file=${item.path}`);
    },
    calcTotal() {
      let result = 0;
      this.item.detailItems.forEach((detailItem) => {
        result += detailItem.price + detailItem.tax;
      });
      return result.toLocaleString();
    },
    createStripe() {
      const elements = this.stripe.elements();

      const style = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };

      this.card = elements.create('card', { style, hidePostalCode: true });
      this.card.mount('#card-element');

      this.card.on('change', (event) => {
        const displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });
    },
    pay() {
      console.log(this.requestItem);
      if (!this.requestItem.client_secret) {
        alert('一時エラー');
        window.location.reload();
      }
      this.paid = true;
      this.stripe.confirmCardPayment(
        this.requestItem.client_secret,
        {
          payment_method: { card: this.card }
        }
      ).then((result) => {
        if (result.error) {
          // Display error.message in your UI.
          const errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
        } else {
          // The payment has succeeded
          // Display a success message
          const reqData = {
            request_id: this.$route.params.id
          };
          this.$store.dispatch('stripe', reqData)
            .then((res) => {
              if (res.status !== 201) {
                alert('決済エラー');
              } else {
                this.paymentCompleteDialog = true;
                this.readyStripe = false;
              }
            })
            .catch(() => {
              alert('決済できませんでした。');
            });
        }
      });
    },
    closePaymentComplete() {
      this.showCredit = false;
      this.$store.dispatch('getRequestItems')
        .then(() => {
          this.item = this.$store.state.requestItems.find((requestItem) => {
            return requestItem.id === Number(this.$route.params.id);
          });
          if (!this.item) {
            this.error = true;
          }
          this.paymentCompleteDialog = false;
        });
    },
    updateStateToFormalRequest() {
      const reqData = {
        request_id: this.item.id,
        state: '正式発注'
      };
      this.$store.dispatch('putRequestState', reqData).then(() => {
        this.updateStateCompleteDialog = true;
      });
    },
    closeUpdateStateComplete() {
      this.$store.dispatch('getRequestItems')
        .then(() => {
          this.item = this.$store.state.requestItems.find((requestItem) => {
            return requestItem.id === Number(this.$route.params.id);
          });
          if (!this.item) {
            this.error = true;
          }
          this.updateStateCompleteDialog = false;
          if (this.item.payment_method === 'クレジット決済') {
            if (this.item.is_paid === 0) {
              if (this.item.state === '正式発注') {
                this.$nextTick(() => {
                  this.createStripe();
                });
              }
            }
          }
        });
    }
  }
};
</script>

<style scoped>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.bank-info table {
  width: 100%;
  margin-bottom: 1rem;
}
.bank-info table, .bank-info th, .bank-info td {
  border-collapse: collapse;
  border: 1px solid #ccc;
  line-height: 1.5;
  padding: 0.5em;
}
.bank-info th {
  width: 10rem;
  color: #424242;
  text-align: left;

}

</style>
